import type React from 'react';
import SvgIcon from './SvgIcon';

const CardSwipe: React.FC = () => (
  <SvgIcon
    width="26"
    height="16"
    viewBox="0 0 26 16"
    fill="none"
  >
    <g id="CardSwipe">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 0C20.1569 1.61066e-07 21.5 1.34315 21.5 3V13C21.5 14.6569 20.1569 16 18.5 16H3.5C1.84315 16 0.5 14.6569 0.5 13V3C0.5 1.34315 1.84315 8.05319e-09 3.5 0H18.5ZM2.5 6.5V13C2.5 13.5523 2.94772 14 3.5 14H18.5C19.0523 14 19.5 13.5523 19.5 13V6.5H2.5ZM3.5 2C2.94772 2 2.5 2.44772 2.5 3V4.5H19.5V3C19.5 2.44772 19.0523 2 18.5 2H3.5Z"
        fill="currentColor" />
    </g>
  </SvgIcon>
);

export default CardSwipe;
